(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-ks-collection-sort]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.href);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ks-product-guide"] && !Shopify.designMode) return;
  try {
    
  const activateGuideFilter = (section, selected, scrollToCollection, filterCards = true) => {
    if (filterCards) {
      section.querySelectorAll('[data-guide-filter]').forEach((item) => {
        const active = item.dataset.guideFilter === selected;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      section.querySelectorAll('[data-guide-card]').forEach((card) => {
        card.hidden = selected !== 'all' && card.dataset.guideCard !== selected;
      });
    }
    let activePanel = null;
    section.querySelectorAll('[data-guide-collection]').forEach((panel) => {
      const active = selected !== 'all' && panel.dataset.guideCollection === selected;
      panel.hidden = !active;
      if (active) activePanel = panel;
    });
    if (scrollToCollection && activePanel) {
      window.requestAnimationFrame(() => activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-guide-filter]');
    if (button) {
      activateGuideFilter(button.closest('.ks-guide'), button.dataset.guideFilter, false);
      return;
    }
    const cardButton = event.target.closest('[data-guide-expand]');
    if (cardButton) activateGuideFilter(cardButton.closest('.ks-guide'), cardButton.dataset.guideExpand, true, false);
  });

  document.querySelectorAll('.ks-guide').forEach((section) => {
    const track = section.querySelector('[data-guide-results]');
    const progress = section.querySelector('[data-guide-progress]');
    if (!track || !progress) return;
    const updateProgress = () => {
      const max = Math.max(track.scrollWidth - track.clientWidth, 1);
      progress.style.transform = `scaleX(${Math.min(1, 0.25 + (track.scrollLeft / max) * 0.75)})`;
    };
    section.querySelector('[data-guide-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.88, behavior: 'smooth' }));
    section.querySelector('[data-guide-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.88, behavior: 'smooth' }));
    track.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch') return;
    const image = event.target.closest('.ks-guide__collection .product-grid-item__images');
    const card = image?.closest('product-grid-item');
    if (!card) return;
    card.dataset.touchTimer = window.setTimeout(() => card.classList.add('ks-touch-active'), 500);
  }, { passive: true });

  ['pointerup', 'pointercancel', 'pointermove'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.pointerType !== 'touch') return;
      const card = event.target.closest('.ks-guide__collection product-grid-item');
      if (!card) return;
      if (eventName === 'pointermove') {
        window.clearTimeout(Number(card.dataset.touchTimer));
        return;
      }
      window.clearTimeout(Number(card.dataset.touchTimer));
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ks-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const color = event.target.closest('[data-look-color]');
    if (color) {
      const card = color.closest('.ks-look-product');
      card.querySelectorAll('[data-look-color]').forEach(button => {
        const current = button === color;
        button.classList.toggle('is-current', current);
        button.setAttribute('aria-pressed', String(current));
      });
      card.querySelectorAll('a[data-ks-quick-shop-link]').forEach(link => { link.href = color.dataset.productUrl; });
      const photo = card.querySelector('.ks-look-product__photo');
      if (photo && color.dataset.imageUrl) { photo.src = color.dataset.imageUrl; photo.srcset = ''; photo.alt = color.dataset.productTitle; }
      card.querySelector('.ks-look-product__title').textContent = color.dataset.productTitle;
      card.querySelector('.ks-look-product__price').textContent = color.dataset.productPrice;
      return;
    }
    const open = event.target.closest('[data-look-open]');
    if (open) {
      const drawer = document.getElementById(open.dataset.lookOpen);
      if (drawer && !drawer.open) {
        drawer.showModal();
        document.documentElement.classList.add('ks-look-open');
      }
      return;
    }
    const close = event.target.closest('[data-look-close]');
    if (close) {
      const drawer = close.closest('[data-look-drawer]');
      if (drawer?.open) drawer.close();
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.ks-look__drawer .product__popdown__cart')) return;
    const drawer = event.target.closest('.ks-look__drawer');
    if (drawer?.open) drawer.close();
  }, true);

  document.addEventListener('close', (event) => {
    if (event.target.matches?.('[data-look-drawer]')) {
      document.documentElement.classList.remove('ks-look-open');
      const popdown = event.target.querySelector('[data-product-add-popdown-wrapper]');
      const header = document.querySelector('[data-section-type="header"]');
      if (popdown && header) header.append(popdown);
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ks-shoppable-stories-02"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-story-preview-open]');
    const close = event.target.closest('[data-story-preview-close]');
    const modal = open ? document.getElementById(open.dataset.storyPreviewOpen) : close?.closest('[data-story-preview-modal]');
    if (!modal) return;
    modal.hidden = open ? false : true;
    document.body.classList.toggle('ks-story-preview-open', open != null);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ks-shoppable-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ks-story-hotspot]');
    if (!button) return;
    const popover = document.getElementById(button.getAttribute('aria-controls'));
    const willOpen = popover.hidden;
    popover.hidden = !willOpen;
    button.setAttribute('aria-expanded', String(willOpen));
  });

  document.querySelectorAll('.ks-stories').forEach((section) => {
    const delay = Number(section.dataset.bubbleDelay || 3000);
    const duration = Number(section.dataset.bubbleDuration || 6000);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.target.dataset.bubbleStarted) return;
        entry.target.dataset.bubbleStarted = 'true';
        window.setTimeout(() => {
          entry.target.querySelectorAll('[data-auto-bubble]').forEach((button) => {
            const popover = document.getElementById(button.getAttribute('aria-controls'));
            if (!popover) return;
            popover.hidden = false;
            button.setAttribute('aria-expanded', 'true');
            window.setTimeout(() => {
              popover.hidden = true;
              button.setAttribute('aria-expanded', 'false');
            }, duration);
          });
        }, delay);
      });
    }, { threshold: 0.35 });
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ks-size-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-size-tab]');
    if (!tab) return;
    const section = tab.closest('.ks-size-guide');
    section.querySelectorAll('[data-size-tab]').forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
    });
    section.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
